import { useMemo } from 'react';
import { StyleSheet } from '@react-pdf/renderer';

export const useStyles = () => {
  return useMemo(
    () =>
      StyleSheet.create({
        root: { paddingVertical: 10 },
        header: {
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignContent: 'center',
          paddingBottom: 5,
        },
        title: { fontSize: 9, fontWeight: 'normal' },
        value: { fontSize: 10, fontWeight: 'bold' },
        listContainer: {
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
        },
        listItem: { fontSize: 10, fontWeight: 'bold' },
      }),
    [],
  );
};
